import { render, staticRenderFns } from "./CustomRadioQuestion.vue?vue&type=template&id=19dfc454&scoped=true"
import script from "./CustomRadioQuestion.vue?vue&type=script&lang=js"
export * from "./CustomRadioQuestion.vue?vue&type=script&lang=js"
import style0 from "./CustomRadioQuestion.vue?vue&type=style&index=0&id=19dfc454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dfc454",
  null
  
)

export default component.exports